import React from 'react';
import { noop } from 'lodash';
import { useTranslation } from 'react-i18next';
import ConfirmModal from 'src/components/confirm-modal';
import ConfirmFitItem from 'src/components/confirm-fit-item';
import Exclamation from "src/assets/img/icon_exclamation_circle.svg";
import './style.scss';

/**
 * Renders a confirm fit modal component.
 *
 * @param {Object} props - The props for the ConfirmFitModal component.
 * @param {Function} props.onCancel - The callback function to handle the modal cancel event.
 * @param {Function} props.onConfirm - The callback function to handle the modal confirm event.
 * @param {Array} props.deallocations - The array of deallocation objects.
 * @param {string} props.type - The string of the object type.
 * @param {Object} props.fitData - The object containing deallocation and need data.
 * @param {Array} props.deallocationIds - The array of deallocation ids.
 * @returns {JSX.Element} The rendered ConfirmFitModal component.
 * @example
 *  <ConfirmFitModal
        onConfirm={cancelMatch}
        onCancel={() => setConfirmRollback(null)}
        fitData={confirmRollback}
        deallocations={deallocations}
        type={type}
        deallocationIds=(deallocationIds)
    />
 */
function ConfirmFitModal({
    onCancel,
    onConfirm,
    deallocations,
    type,
    fitData,
    deallocationIds,
    loading
}) {

    const { t } = useTranslation();

       return (
      <div>
        <ConfirmModal
          onCancel={onCancel}
          onConfirm={() =>
            onConfirm(fitData.deallocationId, fitData.matchNeedId)
          }
          okText={t('confirm')}
          cancelText={t('cancel')}
          title={t('confirmFit')}
          visible={true}
          className="confirm-fit"
          confirmLoading={loading} // Add the loading state to the modal
          okButtonProps={{ disabled: loading }} // Optionally disable the OK button while loading
          cancelButtonProps={{ disabled: loading }} // Optionally disable the cancel button while loading
        >
          <div className="confirm-fit__container">
            <p
              className="confirm-fit__container_subtitle"
              role="note"
              tabIndex={0}
            >
              {t('confirmFitSubtitle')}
            </p>
            <ConfirmFitItem
              fitPeople={fitData}
              type={type}
              deallocationIds={deallocationIds}
              deallocations={deallocations}
            />
          </div>

          <div
            className="confirm-fit__alert"
            tabIndex={0}
            role="alert"
            aria-describedby="alert-container"
          >
            <img src={Exclamation} alt="exclamation" />
            <span className="confirm-fit__alert_text">
              {t('decisionRegardingFit')}
            </span>
          </div>
        </ConfirmModal>
      </div>
    );
}

ConfirmFitModal.defaultProps = {
    onCancel: noop,
    onConfirm: noop,
    deallocations: [],
    fitData: {},
    type: '',
    deallocationIds: []
};

export default ConfirmFitModal;
